import { Bars3Icon } from "@heroicons/react/16/solid";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { logout } from "../../../../Redux Store/Slices/auth";

const PAGE_TITLES = {
  "/": "Dashboard",
  "/leads": "Leads",
  "/advisors": "Advisors",
  "/insurance-providers": "Company",
  "/configurations": "Configurations",
  "/remuneration": "Remuneration",
  "/learning-module": "Learning Module",
  "/become-advisor": "Become Advisor",
  "/relationship-manager": "Relationship Manager",
  "/location": "Locations",
  "/users": "Users",
  "/notifications": "Notifications",
  "/invoice": "Invoice",
  "/mobileconfigurations": "Mobile Configurations",
  "/product-catalogue": "Products",
};

const Appbar = ({ setOpen }) => {
  const ctx = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const userName = ctx?.first_name
    ? `${ctx.first_name} ${ctx.last_name || ""}`.trim()
    : ctx?.name || "Admin";
  const initials = userName.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase();
  const pageTitle = PAGE_TITLES[location.pathname] || "";

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <div className="flex items-center gap-4 py-3 px-5 border-b border-[#E8EDF2] bg-white" style={{ minHeight: 56 }}>
      {/* Mobile menu toggle */}
      <div className="w-6 h-6 block md:hidden cursor-pointer" onClick={() => setOpen(true)}>
        <Bars3Icon fontSize={24} color="#64748B" />
      </div>

      {/* Page title */}
      {pageTitle && (
        <div className="hidden md:flex items-center gap-2">
          <span className="text-sm text-[#94A3B8]">Admin</span>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#CBD5E1" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
          <span className="text-sm font-semibold text-[#0F172A]">{pageTitle}</span>
        </div>
      )}

      <div className="flex items-center gap-3 ml-auto">
        {/* Date badge */}
        <div className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 bg-[#F8FAFC] border border-gray-100 rounded-lg text-xs text-[#64748B]">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
          </svg>
          {new Date().toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
        </div>

        {/* User avatar + dropdown */}
        <div className="relative">
          <button
            onClick={() => setDropdownOpen(o => !o)}
            className="flex items-center gap-2 px-3 py-1.5 rounded-xl hover:bg-[#F8FAFC] transition-colors border border-transparent hover:border-gray-100"
          >
            <div style={{
              width: 32, height: 32, borderRadius: "50%",
              background: "#EAF4FF", color: "#0184FF",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 12, fontWeight: 700, flexShrink: 0
            }}>
              {initials}
            </div>
            <div className="hidden sm:block text-left">
              <p className="text-sm font-semibold text-[#0F172A] leading-tight">{userName}</p>
              <p className="text-xs text-[#64748B] leading-tight">{ctx?.rm_id ? "RM" : "Super Admin"}</p>
            </div>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2" className={`transition-transform ${dropdownOpen ? "rotate-180" : ""}`}>
              <polyline points="6 9 12 15 18 9"/>
            </svg>
          </button>

          {dropdownOpen && (
            <>
              <div className="fixed inset-0 z-10" onClick={() => setDropdownOpen(false)} />
              <div className="absolute right-0 top-full mt-2 w-52 bg-white rounded-2xl shadow-lg border border-gray-100 py-2 z-20">
                <div className="px-4 py-3 border-b border-gray-50">
                  <p className="text-sm font-semibold text-[#0F172A]">{userName}</p>
                  <p className="text-xs text-[#64748B] mt-0.5">{ctx?.email || ""}</p>
                </div>
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm text-[#EF4444] hover:bg-red-50 transition-colors"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                    <polyline points="16 17 21 12 16 7"/>
                    <line x1="21" y1="12" x2="9" y2="12"/>
                  </svg>
                  Logout
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Appbar;
